import { Link } from 'react-router-dom';

const MaintenanceSection = () => {
  return (
    <section className="py-24 bg-gradient-to-br from-[#3D2817] to-[#2D1810] text-white">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
        <div className="mb-16">
          <div className="mb-6">
            <span className="text-sm font-medium text-purple-300 flex items-center gap-2">
              / MAINTENANCE PLANS
            </span>
          </div>
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
            <div>
              <h2 className="text-5xl font-bold mb-6 leading-tight">
                Peace of Mind Protection
              </h2>
            </div>
            <div>
              <p className="text-gray-300 leading-relaxed mb-4">
                Our comprehensive maintenance plans ensure your security systems operate at peak performance year-round. From routine inspections to priority support, we offer flexible service tiers designed to meet the unique needs of both residential and commercial clients.
              </p>
              <p className="text-gray-300 leading-relaxed">
                Choose from our Basic, Professional, or Enterprise plans to receive regular system health checks, software updates, and rapid response times when you need assistance most.
              </p>
            </div>
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-center">
          <div className="rounded-2xl overflow-hidden h-[400px]">
            <img
              src="https://public.readdy.ai/ai/img_res/f51863a4fcee6b5702cc5b2bb59428a1.jpg"
              alt="Maintenance Service"
              className="w-full h-full object-cover"
            />
          </div>

          <div>
            <div className="mb-8">
              <div className="text-8xl font-serif font-bold mb-4">3</div>
              <p className="text-xl text-gray-300">
                Flexible maintenance tiers designed for your needs
              </p>
            </div>
            <Link
              to="/support"
              className="inline-flex items-center gap-3 bg-white text-dark px-8 py-4 rounded-full font-medium hover:bg-gray-100 transition-colors cursor-pointer whitespace-nowrap"
            >
              VIEW PLANS
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default MaintenanceSection;